export default __webpack_public_path__ + "static/media/resume.4ab58e92.pdf";